import React, { useContext, useState, useEffect } from "react";
import { LayoutContext } from "./index";
import { getAllLeathersAdmin, getAllOrders } from "./fetchApi";

// Nhúng các thành phần tính năng
import Overview from "./Overview";
import Inventory from "./Inventory";
import Orders from "./Orders";
import Locales from "./Locales";
import Options from "./Options";

const Dashboard = () => {
    const { colors, data } = useContext(LayoutContext);
    const activeTab = data.activeTab || "overview";

    const [leathers, setLeathers] = useState([]);
    const [orders, setOrders] = useState([]);

    const fetchData = async () => {
        try {
            const [resL, resO] = await Promise.all([
                getAllLeathersAdmin(),
                getAllOrders()
            ]);
            const leatherList = resL?.Leathers || resL?.leathers || [];
            setLeathers(leatherList);
            // Handle both capitalizations: backend may return Orders or orders
            const orderList = resO?.Orders || resO?.orders || [];
            setOrders(orderList);
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div
            className="w-100 min-vh-100 p-4"
            style={{
                backgroundColor: colors.bgApp,
                color: colors.textMain,
                transition: "all 0.3s ease"
            }}
        >
            <div className="animate-fade-in">
                {activeTab === "overview" && <Overview leathers={leathers} orders={orders} colors={colors} />}
                {activeTab === "inventory" && <Inventory leathers={leathers} fetchData={fetchData} colors={colors} />}
                {activeTab === "orders" && <Orders orders={orders} colors={colors} />}

                {activeTab === "locales" && <Locales colors={colors} />}
                {activeTab === "options" && <Options colors={colors} />}
            </div>
        </div>
    );
};

export default Dashboard;